/* eslint-disable react/button-has-type */
import React from 'react';

function Footer() {
  return (
    <div className="footer-main">
      <div className="footer-inner">
        <div className="talk-input-main">
          <div className="so-we-do">
            <h3>So, do we work together</h3>
            <a href="/">LET&apos;S TALK!</a>
          </div>
          <div className="input-btn">
            <h3>A treat for your inbox</h3>
            <div className="input-input">
              <input type="text" placeholder="Email Address" />
              <button>Subscribe</button>
            </div>
          </div>
        </div>
        <div className="icons-contact-main">
          <div className="icons-main-main">
            <div className="icons-div">
              <a
                aria-label="social icon"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/SWdesigns720"
              >
                <i style={{ display: 'inline-block' }}>
                  <svg
                    fill="currentColor"
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    height="22"
                    width="22"
                    viewBox="0 0 512 512"
                  >
                    <path d="M288,192v-38.1c0-17.2,3.8-25.9,30.5-25.9H352V64h-55.9c-68.5,0-91.1,31.4-91.1,85.3V192h-45v64h45v192h83V256h56.4l7.6-64H288z" />
                  </svg>
                </i>
              </a>

              {/* LinkedIn Icon */}
              <a
                aria-label="social icon"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/in/m-amman/"
              >
                <i style={{ display: 'inline-block' }}>
                  <svg
                    fill="currentColor"
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    height="22"
                    width="22"
                    viewBox="0 0 1536 1792"
                  >
                    <path d="M237 1414h231v-694h-231v694zM483 506q-1-52-36-86t-93-34-94.5 34-36.5 86q0 51 35.5 85.5t92.5 34.5h1q59 0 95-34.5t36-85.5zM1068 1414h231v-398q0-154-73-233t-193-79q-136 0-209 117h2v-101h-231q3 66 0 694h231v-388q0-38 7-56 15-35 45-59.5t74-24.5q116 0 116 157v371zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z" />
                  </svg>
                </i>
              </a>

              {/* GitHub Icon */}
              <a
                aria-label="social icon"
                target="_blank"
                rel="noopener noreferrer"
                href="https://github.com/MuhammadAmann"
              >
                <i style={{ display: 'inline-block' }}>
                  <svg
                    fill="currentColor"
                    style={{ display: 'inline-block', verticalAlign: 'middle' }}
                    height="22"
                    width="22"
                    viewBox="0 0 512 512"
                  >
                    <path d="M256,32C132.3,32,32,134.9,32,261.7c0,101.5,64.2,187.5,153.2,217.9c1.4,0.3,2.6,0.4,3.8,0.4c8.3,0,11.5-6.1,11.5-11.4c0-5.5-0.2-19.9-0.3-39.1c-8.4,1.9-15.9,2.7-22.6,2.7c-43.1,0-52.9-33.5-52.9-33.5c-10.2-26.5-24.9-33.6-24.9-33.6c-19.5-13.7-0.1-14.1,1.4-14.1c0.1,0,0.1,0,0.1,0c22.5,2,34.3,23.8,34.3,23.8c11.2,19.6,26.2,25.1,39.6,25.1c10.5,0,20-3.4,25.6-6c2-14.8,7.8-24.9,14.2-30.7c-49.7-5.8-102-25.5-102-113.5c0-25.1,8.7-45.6,23-61.6c-2.3-5.8-10-29.2,2.2-60.8c0,0,1.6-0.5,5-0.5c8.1,0,26.4,3.1,56.6,24.1c17.9-5.1,37-7.6,56.1-7.7c19,0.1,38.2,2.6,56.1,7.7c30.2-21,48.5-24.1,56.6-24.1c3.4,0,5,0.5,5,0.5c12.2,31.6,4.5,55,2.2,60.8c14.3,16.1,23,36.6,23,61.6c0,88.2-52.4,107.6-102.3,113.3c8,7.1,15.2,21.1,15.2,42.5c0,30.7-0.3,55.5-0.3,63c0,5.4,3.1,11.5,11.4,11.5c1.2,0,2.6-0.1,4-0.4C415.9,449.2,480,363.1,480,261.7C480,134.9,379.7,32,256,32z" />
                  </svg>
                </i>
              </a>
            </div>
            <div className="copyright-text">
              <p>Copyright © 2025 </p>
              <a href="/">Muhammad Aman.</a>
            </div>
          </div>

          <div className="help-main">
            <div className="help-com">
              <p>Need help?</p>
              <h4>Muhammadamann72@gmail.com</h4>
            </div>
            {/* <div className="help-num">
              <p>Feel like talking</p>
              <h4>+1 437 985 8199</h4>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
